import React, { createContext, useState, useContext, ReactNode } from 'react';
import { ConfigProvider, theme } from 'antd';
import enUS from 'antd/es/locale/en_US';

const ThemeContext = createContext<any>(null);
export const useTheme = () => {
  const context = useContext(ThemeContext);
  return context || { isDarkMode: false, setIsDarkMode: () => {} };
};
const lightTheme = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: '#3f4373',
    colorMenuBackground: '#FFFFFF',
    colorBgBase: '#FFFFFF',
  },
  components: {
    Table: {
      headerBg: '#EAECFA',
      headerColor: '#000',
      rowHoverBg: '#d3d6f8',
      rowSelectedBg: '#d3d6f8',
      rowSelectedHoverBg: '#d3d6f8'
    },
    Card: {
      colorBgContainer: '#FFFFFF'
    },
    Menu: {
      itemSelectedBg: '#d3d6f8',
      itemHoverBg: '#d3d6f8',
      itemActiveBg: '#d3d6f8',

    },
    Form: {
      colorText: '#000',
      colorBg: '#ffffff',
      borderColor: '#d9d9d9',
      colorBgContainer: '#ffffff'
    },
    Collapse: {
      headerBg: '#FFFFFF',
      colorText: '#000',
      contentBg: '#FFFFFF'
    },
    Input: {
      colorText: '#000',
      colorBg: '#ffffff',
      colorBgContainer: '#ffffff',
    },
    Tag: {
      colorText: "#000"
    }
  }
};

const darkTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#3f4373',
    colorBgBase: '#1f1f1f',
    colorText: '#ffffff',
  },
  components: {
    Layout: {
      bodyBg: '#1f1f1f',
      siderBg: '#1f1f1f',
      triggerBg: '#1f1f1f',
      triggerColor: '#1f1f1f',
      lightSiderBg: '#1f1f1f',
      colorTextMenu: '#fff',
      colorMenuBackground: '#1f1f1f',
    },
    Table: {
      headerBg: '#3f4373',
      headerColor: '#fff',
      rowHoverBg: '#1f1f1f',
      rowSelectedBg: '#1f1f1f',
      rowSelectedHoverBg: '#1f1f1f',
      headerSortActiveBg: '#3f4373',
      headerSortHoverBg: '#3f4373'
    },
    Card: {
      colorBgContainer: '#1f1f1f'
    },
    Menu: {
      itemSelectedColor: '#fff',
      itemSelectedBg: '#151b23',
      itemHoverBg: '#151b23',
      itemActiveBg: '#151b23',
      itemBg: '#1f1f1f',
      colorBgContainer: "#1f1f1f",
      // darkItemBg: "#001529",
    },
    Select: {
      dropdownBg: '#1f1f1f', 
      itemHoverBg: '#3f4373',
      itemSelectedBg: '#3f4373',
      itemColor: '#fff', 
      itemSelectedColor: '#fff', 
      borderColor: '#3f4373', 
      colorBgContainer: '#1f1f1f', 
      placeholderColor: '#757575'
    },
    Checkbox: {
      colorText: '#fff',
      colorBg: '#1f1f1f', 
      borderColor: '#3f4373',
      colorCheck: '#3f4373' 
    },
    Form: {
      colorText: '#fff',
      colorBg: '#1f1f1f', 
      borderColor: '#3f4373', 
      colorBgContainer: '#1f1f1f', 
    },
    Collapse: {
      headerBg: '#1f1f1f', 
      colorText: '#fff', 
      contentBg: "#1f1f1f" 
    },
    Input: {
      colorText: '#fff', // Text color for the textarea
      colorBg: '#1f1f1f',
      colorBgContainer: '#1f1f1f',
    },
    Tag: {
      colorText: "#fff"
    }
  }
};

export const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const themeX = isDarkMode ? darkTheme : lightTheme;

  const contextValue = React.useMemo(() => ({ isDarkMode, toggleTheme }), [isDarkMode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      <ConfigProvider theme={{ ...themeX }} locale={enUS}>
        {children}
      </ConfigProvider>
    </ThemeContext.Provider>
  );
};
